<script lang="ts">
	import { scooterStorage } from '../../stores/preferences';
	import LeftFilterProducts from '../../components/LeftFilterProducts.svelte';
	import ProductListItem from './ProductListItem.svelte';
	import Breadcrumb from '../../components/Breadcrumb.svelte';
	import ItemSorting from './ItemSorting.svelte';
	import CategoriesNavigation from './CategoriesNavigation.svelte';
	import SearchPartBox from './SearchPartBox.svelte';
	import OurAdvantages from './OurAdvantages.svelte';
	import TyreSelector from './TyreSelector.svelte';
	import { _CategoriesEnum_t } from '$lib/utils/Enums';
	import Alert from './Alert.svelte';
	import UniversalPartsList from "$lib/components/universalPartsList/UniversalPartsList.svelte";
	export let data;
	export let breadcrumbsData;
	export let tyreSelectorData = undefined;
	export let showCompatibility = true;
	export let selected_scooter: any = null;
	export let prerenderCommand = false;
	export let showRelatedUniversalPartsCategories = false;
	export let universal_categories: null | any = null;
	export let category_name: null | string = null;
	let products = data?.products || data?.subcategoryProducts;

	initProducersFilter();
	initAvilabilitiesFilter();

	
	// filter all producres from subcategoryProducts
	// create array of objects with producer name and count of products in producer
	// data.producres = [{name: 'producer', count: 5}]
	function initProducersFilter() {
		if (products?.data?.length) {
			data.producers = products?.data.reduce((acc, item) => {
				const producer = acc.find((producer) => producer.name === item.producer);
				if (producer) {
					producer.count++;
				} else {
					acc.push({ name: item.producer, count: 1 });
				}
				return acc;
			}, []);
		} else {
			data.producers = [];
		}
	}

	// filter all products by availability
	// create array of objects with availability name and count of products in availability
	// data.availabilities = [{name: 'availability', count: 5}] with interface IFilterItem
	// availability_location
	function initAvilabilitiesFilter() {
		if (products?.data?.length) {
			data.availabilities = products?.data.reduce((acc, item) => {
				const availability = acc.find((availability) => availability.name === item.availability_location);
				if (availability) {
					availability.count++;
				} else {
					acc.push({ name: item.availability_location, count: 1 });
				}
				return acc;
			}, []);

			// sort Availability by order
			data.availabilities.sort((a, b) => {
				const availabilityOrder = [
					"skladem",        // 1. místo
					"u dodavatele",   // 2. místo
					"na dotaz",       // 4. místo
					"na objednávku",  // 3. místo
					"nedostupné",     // 5. místo
				];
				return availabilityOrder.indexOf(a.name) - availabilityOrder.indexOf(b.name);
			});
		} else {
			data.availabilities = [];
		}
	}
	
	// Enum type for category type
	export let categoryType: _CategoriesEnum_t = _CategoriesEnum_t.NEW;


	function handleSortChange(event: any) {
		products.data = event.detail.products.data;
	}
	
	function handleFilterChange(event: any) {
		products.data = event.detail.filteredProducts;
	}
</script>

{#if breadcrumbsData}
	<Breadcrumb breadcrumbs={breadcrumbsData} />
{/if}

<div class="container mx-auto mt-4 flex flex-col sm:flex-row md:mt-9">
	<LeftFilterProducts
		categories={data.categories}
		slug={data.slug}
		{categoryType}
		{selected_scooter}
		producers={data?.producers}
		availabilities={data?.availabilities}
		title="Univerzální díly"
		data = {products.data}
		on:filterChange={handleFilterChange}
	/>

	<div class="mb-8 w-full px-2.5 md:w-2/3 md:pl-8 lg:w-4/5">
		<div class="flex flex-col gap-y-6 md:gap-y-4">
			<!-- compatibility Note (client side) -->
			{#if showCompatibility}
				{#if data?.scooterSplitUrl === $scooterStorage.url}
					{#if $scooterStorage.producer && $scooterStorage.ccm && $scooterStorage.url}
						<div
							class="w-full cursor-default bg-green-zanah p-4 text-center md:text-left mdmax:order-3"
						>
							Všechno zboží na stránce je plně kompatibilní se skútrem
							<a href="/skutr-{$scooterStorage.url}" title={$scooterStorage.name}>
								{$scooterStorage.producer}
								{$scooterStorage.name}
							</a>
						</div>
					{/if}
				{:else}
					<div class="w-full cursor-default bg-red p-4 text-center md:text-left mdmax:order-3">
						Toto zboží není kompatibilní s vámi vybraným skútrem <a
							href="/skutr-{$scooterStorage.url}"
							title={$scooterStorage.name}
						>
							{$scooterStorage.producer}
							{$scooterStorage.name}
						</a>
					</div>
				{/if}
			{/if}
			{#if selected_scooter}
				<div class="flex justify-between gap-x-4 mdmax:order-1 flex-wrap">
				<h1 class="w-full text-2xl font-bold">{categoryType === _CategoriesEnum_t.USED ? "Použité " +products.category_name.charAt(0).toLowerCase()+products.category_name.slice(1): products.category_name} pro {selected_scooter.producer}
					{selected_scooter.name} {selected_scooter.ccm} ccm </h1>

				{#if data?.categories && data?.categories.length}
					<CategoriesNavigation data={data.categories} {categoryType} />
				{/if}
			</div>
				{:else}
				<h1 class="w-full text-2xl font-bold"> {products.category_name}</h1>
			{/if}

			{#if products.category_description}
				<p class="hidden sm:block mdmax:order-2">
					{products.category_description}
				</p>
			{/if}

		
		</div>

		{#if tyreSelectorData}
			<TyreSelector data={tyreSelectorData} />
		{/if}

		{#if products.data?.length > 0}
			<ItemSorting sorting={data?.sorting} count={products.data?.length} {products} 
						 on:sortChange={handleSortChange}/>
			{:else }
			{#if tyreSelectorData}
				<Alert type="warning" class={$$props.class}>
					Žádné pneumatiky nebyly nalezeny, vyberte prosím parametry.
				</Alert>
				{:else}
				<Alert type="warning" class={$$props.class}>

					{#if selected_scooter}
					Nemáme žádné {categoryType === _CategoriesEnum_t.USED ? "použité " : ""} {products.category_name.charAt(0).toLowerCase()+products.category_name.slice(1)} pro {selected_scooter.producer}
						{selected_scooter.name} {selected_scooter.ccm} ccm. <br>
						Vyplňte formulář níže a my vám díl rádi dohledáme.
	
					{:else}
					Žádné produkty nebyly nalezeny.
					{/if}
				</Alert>
				{/if}
			
		{/if}
		
		{#if products.data && products.data.length > 0}
			<div class="mt-6 flex flex-col gap-y-4 md:gap-y-5">
				{#each products.data as article}
					<ProductListItem {article} class="!m-0"
									 key={article.id}
									 prerenderCommand={prerenderCommand}
					/>
				{/each}
			</div>
		{/if}

		{#if products?.category_text}
			<p class="mt-4"> {products.category_text} </p>
		{/if}
		
		{#if showRelatedUniversalPartsCategories && universal_categories && category_name}
			<UniversalPartsList universal_categories={universal_categories} current_category_name={category_name} />
		{/if}

		<SearchPartBox class="my-12" />
	</div>
</div>

<OurAdvantages />
